import {
  AFFIDAVIT_CONSENT_BEGIN,
  AFFIDAVIT_CONSENT_SUCCESS,
  AFFIDAVIT_CONSENT_FAILURE,
  REQUEST_DELETE_BEGIN,
  REQUEST_DELETE_SUCCESS,
  REQUEST_DELETE_FAILURE,
  REQUEST_DOWNLOAD_BEGIN,
  REQUEST_DOWNLOAD_SUCCESS,
  REQUEST_DOWNLOAD_FAILURE,
  FETCH_REQUEST_HISTORY_BEGIN,
  FETCH_REQUEST_HISTORY_FAILURE,
  FETCH_REQUEST_HISTORY_SUCCESS,
  CANCEL_DELETE_BEGIN,
  CANCEL_DELETE_SUCCESS,
  CANCEL_DELETE_FAILURE,
  CANCEL_DOWNLOAD_BEGIN,
  CANCEL_DOWNLOAD_SUCCESS,
  CANCEL_DOWNLOAD_FAILURE,
  FETCH_PAGE_CONTENT_BEGIN,
  FETCH_PAGE_CONTENT_SUCCESS,
  FETCH_PAGE_CONTENT_FAILURE,
  SEND_SECURE_PIN_TO_DEVICE_BEGIN,
  SEND_SECURE_PIN_TO_DEVICE_SUCCESS,
  SEND_SECURE_PIN_TO_DEVICE_FAILURE,
  VALIDATE_SECURE_PIN_BEGIN,
  VALIDATE_SECURE_PIN_SUCCESS,
  VALIDATE_SECURE_PIN_FAILURE,
  FETCH_PROFILE_API_BEGIN,
  FETCH_PROFILE_API_FAILURE,
  FETCH_PROFILE_API_SUCCESS,
  CHECK_IF_MDN_SMS_CAPABLE_SUCCESS,
  CHECK_IF_MDN_SMS_CAPABLE_BEGIN,
  CHECK_IF_MDN_SMS_CAPABLE_FAILURE,
  FETCH_MARKETING_PREFERENCES_BEGIN,
  FETCH_MARKETING_PREFERENCES_SUCCESS,
  FETCH_MARKETING_PREFERENCES_FAILURE,
  SET_MARKETING_PREFERENCES_BEGIN,
  SET_MARKETING_PREFERENCES_SUCCESS,
  SET_MARKETING_PREFERENCES_FAILURE,
  RESEND_PASSWORD_BEGIN,
  RESEND_PASSWORD_SUCCESS,
  RESEND_PASSWORD_FAILURE,
  CLEAR_ERRORS
} from "../actions/types";

import {
  SUBMIT_AUTH_AGENT_BEGIN,
  SUBMIT_AUTH_AGENT_SUCCESS,
  SUBMIT_AUTH_AGENT_FAILURE
} from "../../AuthorizedAgent/AssignAgentForm/actions/types";

import {
  RENEW_OR_REMOVE_AUTH_AGENT_BEGIN,
  RENEW_OR_REMOVE_AUTH_AGENT_SUCCESS,
  RENEW_OR_REMOVE_AUTH_AGENT_FAILURE
} from "../../AuthorizedAgent/ManageAuthorizedAgent/actions/types";

import {
  FETCH_CUSTOMER_HISTORY_BEGIN,
  FETCH_CUSTOMER_HISTORY_SUCCESS,
  FETCH_CUSTOMER_HISTORY_FAILURE,
  AGENT_DELETE_REQUEST_BEGIN,
  AGENT_DELETE_REQUEST_SUCCESS,
  AGENT_DELETE_REQUEST_FAILURE,
  AGENT_DOWNLOAD_REQUEST_BEGIN,
  AGENT_DOWNLOAD_REQUEST_SUCCESS,
  AGENT_DOWNLOAD_REQUEST_FAILURE,
  AGENT_CANCEL_DOWNLOAD_BEGIN,
  AGENT_CANCEL_DOWNLOAD_SUCCESS,
  AGENT_CANCEL_DOWNLOAD_FAILURE
} from "../../AuthorizedAgent/actions/types";

import {
  VERIFY_FORMER_CUSTOMER_BEGIN,
  VERIFY_FORMER_CUSTOMER_SUCCESS,
  VERIFY_FORMER_CUSTOMER_FAILURE,
  DELETE_FORMER_PERSONAL_DATA_BEGIN,
  DELETE_FORMER_PERSONAL_DATA_SUCCESS,
  DELETE_FORMER_PERSONAL_DATA_FAILURE
} from "../../FormerCustomer/actions/types";

import {
  FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_BEGIN,
  FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_SUCCESS,
  FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_FAILURE,
  PENDING_CASE_BEGIN,
  PENDING_CASE_SUCCESS,
  PENDING_CASE_FAILURE,
  FORMER_CUSTOMER_ADDRESS_DOB_BEGIN,
  FORMER_CUSTOMER_ADDRESS_DOB_SUCCESS,
  FORMER_CUSTOMER_ADDRESS_DOB_FAILURE,
  FORMER_CUSTOMER_CREATE_CASE_BEGIN,
  FORMER_CUSTOMER_CREATE_CASE_SUCCESS,
  FORMER_CUSTOMER_CREATE_CASE_FAILURE,
  CREATE_UUID_BEGIN,
  CREATE_UUID_SUCCESS,
  CREATE_UUID_FAILURE,
  CREATE_TIME_FRAME_BEGIN,
  CREATE_TIME_FRAME_SUCCESS,
  CREATE_TIME_FRAME_FAILURE,
  CREATE_FILE_FORMAT_BEGIN,
  CREATE_FILE_FORMAT_SUCCESS,
  CREATE_FILE_FORMAT_FAILURE,
  FORMER_DOC_VERIFICATION_BEGIN,
  FORMER_DOC_VERIFICATION_SUCCESS,
  FORMER_DOC_VERIFICATION_FAILURE,
  FORMER_VALIDATE_SECURE_PIN_BEGIN,
  FORMER_VALIDATE_SECURE_PIN_SUCCESS,
  FORMER_VALIDATE_SECURE_PIN_FAILURE,
  CLOSE_CASEID_BEGIN,
  CLOSE_CASEID_SUCCESS,
  CLOSE_CASEID_FAILURE,
  BREADCRUMBS_LINK_BEGIN,
  BREADCRUMBS_LINK_SUCCESS,
  BREADCRUMBS_LINK_FAILURE,
} from "../../FormerCustomer/actions/types";

import {
  SUBMIT_APPEAL_BEGIN,
  SUBMIT_APPEAL_SUCCESS,
  SUBMIT_APPEAL_FAILURE,
  CANCEL_APPEAL_BEGIN,
  CANCEL_APPEAL_SUCCESS,
  CANCEL_APPEAL_FAILURE
} from "../../DownloadAndDelete/Appeal/actions/types";

import {
  CANCEL_CORRECTION_BEGIN,
  CANCEL_CORRECTION_SUCCESS,
  CANCEL_CORRECTION_FAILURE,
} from "../../DownloadAndDelete/Correction/actions/types";

import {
  AGENT_SUBMIT_APPEAL_BEGIN,
  AGENT_SUBMIT_APPEAL_SUCCESS,
  AGENT_SUBMIT_APPEAL_FAILURE,
  AGENT_CANCEL_APPEAL_BEGIN,
  AGENT_CANCEL_APPEAL_SUCCESS,
  AGENT_CANCEL_APPEAL_FAILURE
} from "../../AuthorizedAgent/AuthorizedAgentAppeal/actions/types";

import {
  AGENT_CANCEL_CORRECT_BEGIN,
  AGENT_CANCEL_CORRECT_SUCCESS,
  AGENT_CANCEL_CORRECT_FAILURE
} from "../../AuthorizedAgent/AuthorizedAgentCorrectionForm/actions/types";

import {
  SUBMIT_CORRECTIBLE_BEGIN,
  SUBMIT_CORRECTIBLE_SUCCESS,
  SUBMIT_CORRECTIBLE_FAILURE
} from "../../CorrectibleData/actions/types";

const initialState = {
  loading: false,
  error: "",
  resendPWError: ""
};

const startLoading = state => ({
  ...state,
  loading: true,
  error: "",
  resendPWError: ""
});

const stopLoading = state => ({
  ...state,
  loading: false
});

const hasError = (state, action) => ({
  ...state,
  loading: false,
  error: action.payload
});

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_ERRORS:
      return {
        ...state,
        error: "",
        resendPWError: ""
      };
    case RESEND_PASSWORD_BEGIN:
      return startLoading(state);

    case RESEND_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        resendPWError: ""
      };

    case RESEND_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        resendPWError: action.payload
      };

    case VERIFY_FORMER_CUSTOMER_BEGIN:
      return startLoading(state);

    case VERIFY_FORMER_CUSTOMER_SUCCESS:
      return stopLoading(state);

    case VERIFY_FORMER_CUSTOMER_FAILURE:
      return hasError(state, action);

    case FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_BEGIN:
      return startLoading(state);

    case FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_SUCCESS:
      return stopLoading(state);

    case FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_FAILURE:
      return hasError(state, action);

    case PENDING_CASE_BEGIN:
      return startLoading(state);

    case PENDING_CASE_SUCCESS:
      return stopLoading(state);

    case PENDING_CASE_FAILURE:
      return hasError(state, action);


    case FORMER_CUSTOMER_CREATE_CASE_BEGIN:
      return startLoading(state);

    case FORMER_CUSTOMER_CREATE_CASE_SUCCESS:
      return stopLoading(state);

    case FORMER_CUSTOMER_CREATE_CASE_FAILURE:
      return hasError(state, action);

    case FORMER_CUSTOMER_ADDRESS_DOB_BEGIN:
      return startLoading(state);

    case FORMER_CUSTOMER_ADDRESS_DOB_SUCCESS:
      return stopLoading(state);

    case FORMER_CUSTOMER_ADDRESS_DOB_FAILURE:
      return hasError(state, action);

    case CREATE_UUID_BEGIN:
      return startLoading(state);

    case CREATE_UUID_SUCCESS:
      return stopLoading(state);

    case CREATE_UUID_FAILURE:
      return hasError(state, action);

    case CREATE_TIME_FRAME_BEGIN:
      return startLoading(state);

    case CREATE_TIME_FRAME_SUCCESS:
      return stopLoading(state);

    case CREATE_TIME_FRAME_FAILURE:
      return hasError(state, action);

    case CREATE_FILE_FORMAT_BEGIN:
      return startLoading(state);

    case CREATE_FILE_FORMAT_SUCCESS:
      return stopLoading(state);

    case CREATE_FILE_FORMAT_FAILURE:
      return hasError(state, action);


    case FORMER_DOC_VERIFICATION_BEGIN:
      return startLoading(state);

    case FORMER_DOC_VERIFICATION_SUCCESS:
      return stopLoading(state);

    case FORMER_DOC_VERIFICATION_FAILURE:
      return hasError(state, action);


    case CLOSE_CASEID_BEGIN:
      return startLoading(state);

    case CLOSE_CASEID_SUCCESS:
      return stopLoading(state);

    case CLOSE_CASEID_FAILURE:
      return hasError(state, action);

      case BREADCRUMBS_LINK_BEGIN:
      return startLoading(state);

    case BREADCRUMBS_LINK_SUCCESS:
      return stopLoading(state);

    case BREADCRUMBS_LINK_FAILURE:
      return hasError(state, action);
      
    case FORMER_VALIDATE_SECURE_PIN_BEGIN:
      return startLoading(state);

    case FORMER_VALIDATE_SECURE_PIN_SUCCESS:
      return stopLoading(state);

    case FORMER_VALIDATE_SECURE_PIN_FAILURE:
      return hasError(state, action);


    case DELETE_FORMER_PERSONAL_DATA_BEGIN:
      return startLoading(state);

    case DELETE_FORMER_PERSONAL_DATA_SUCCESS:
      return stopLoading(state);

    case DELETE_FORMER_PERSONAL_DATA_FAILURE:
      return hasError(state, action);


    case AGENT_CANCEL_DOWNLOAD_BEGIN:
      return startLoading(state);

    case AGENT_CANCEL_DOWNLOAD_SUCCESS:
      return stopLoading(state);

    case AGENT_CANCEL_DOWNLOAD_FAILURE:
      return hasError(state, action);

    case AGENT_DOWNLOAD_REQUEST_BEGIN:
      return startLoading(state);

    case AGENT_DOWNLOAD_REQUEST_SUCCESS:
      return stopLoading(state);

    case AGENT_DOWNLOAD_REQUEST_FAILURE:
      return hasError(state, action);

    case AGENT_DELETE_REQUEST_BEGIN:
      return startLoading(state);

    case AGENT_DELETE_REQUEST_SUCCESS:
      return stopLoading(state);

    case AGENT_DELETE_REQUEST_FAILURE:
      return hasError(state, action);

    case FETCH_CUSTOMER_HISTORY_BEGIN:
      return startLoading(state);

    case FETCH_CUSTOMER_HISTORY_SUCCESS:
      return stopLoading(state);

    case FETCH_CUSTOMER_HISTORY_FAILURE:
      return hasError(state, action);

    case RENEW_OR_REMOVE_AUTH_AGENT_BEGIN:
      return startLoading(state);

    case RENEW_OR_REMOVE_AUTH_AGENT_SUCCESS:
      return stopLoading(state);

    case RENEW_OR_REMOVE_AUTH_AGENT_FAILURE:
      return hasError(state, action);

    case SUBMIT_AUTH_AGENT_BEGIN:
      return startLoading(state);

    case SUBMIT_AUTH_AGENT_SUCCESS:
      return stopLoading(state);

    case SUBMIT_AUTH_AGENT_FAILURE:
      return hasError(state, action);

    case FETCH_MARKETING_PREFERENCES_BEGIN:
      return startLoading(state);

    case FETCH_MARKETING_PREFERENCES_SUCCESS:
      return stopLoading(state);

    case FETCH_MARKETING_PREFERENCES_FAILURE:
      return hasError(state, action);

    case SET_MARKETING_PREFERENCES_BEGIN:
      return startLoading(state);

    case SET_MARKETING_PREFERENCES_SUCCESS:
      return stopLoading(state);

    case SET_MARKETING_PREFERENCES_FAILURE:
      return hasError(state, action);

    case AFFIDAVIT_CONSENT_BEGIN:
      return startLoading(state);

    case AFFIDAVIT_CONSENT_SUCCESS:
      return stopLoading(state);

    case AFFIDAVIT_CONSENT_FAILURE:
      return hasError(state, action);

    case CHECK_IF_MDN_SMS_CAPABLE_BEGIN:
      return startLoading(state);

    case CHECK_IF_MDN_SMS_CAPABLE_SUCCESS:
      return stopLoading(state);

    case CHECK_IF_MDN_SMS_CAPABLE_FAILURE:
      return hasError(state, action);

    case FETCH_PROFILE_API_BEGIN:
      return startLoading(state);

    case FETCH_PROFILE_API_SUCCESS:
      return stopLoading(state);

    case FETCH_PROFILE_API_FAILURE:
      return hasError(state, action);

    case VALIDATE_SECURE_PIN_BEGIN:
      return startLoading(state);

    case VALIDATE_SECURE_PIN_SUCCESS:
      return stopLoading(state);

    case VALIDATE_SECURE_PIN_FAILURE:
      return hasError(state, action);

    case SEND_SECURE_PIN_TO_DEVICE_BEGIN:
      return startLoading(state);

    case SEND_SECURE_PIN_TO_DEVICE_SUCCESS:
      return stopLoading(state);

    case SEND_SECURE_PIN_TO_DEVICE_FAILURE:
      return hasError(state, action);

    case FETCH_PAGE_CONTENT_BEGIN:
      return startLoading(state);

    case FETCH_PAGE_CONTENT_SUCCESS:
      return stopLoading(state);

    case FETCH_PAGE_CONTENT_FAILURE:
      return hasError(state, action);

    case FETCH_REQUEST_HISTORY_BEGIN:
      return startLoading(state);

    case FETCH_REQUEST_HISTORY_SUCCESS:
      return stopLoading(state);

    case FETCH_REQUEST_HISTORY_FAILURE:
      return hasError(state, action);

    case REQUEST_DELETE_BEGIN:
      return startLoading(state);

    case REQUEST_DELETE_SUCCESS:
      return stopLoading(state);

    case REQUEST_DELETE_FAILURE:
      return hasError(state, action);

    case REQUEST_DOWNLOAD_BEGIN:
      return startLoading(state);

    case REQUEST_DOWNLOAD_SUCCESS:
      return stopLoading(state);

    case REQUEST_DOWNLOAD_FAILURE:
      return hasError(state, action);

    case CANCEL_DOWNLOAD_BEGIN:
      return startLoading(state);

    case CANCEL_DOWNLOAD_SUCCESS:
      return stopLoading(state);

    case CANCEL_DOWNLOAD_FAILURE:
      return hasError(state, action);

    case CANCEL_DELETE_BEGIN:
      return startLoading(state);

    case CANCEL_DELETE_SUCCESS:
      return stopLoading(state);

    case CANCEL_DELETE_FAILURE:
      return hasError(state, action);

    case SUBMIT_APPEAL_BEGIN:
      return startLoading(state);

    case SUBMIT_APPEAL_SUCCESS:
      return stopLoading(state);

    case SUBMIT_APPEAL_FAILURE:
      return hasError(state, action);

    case CANCEL_APPEAL_BEGIN:
      return startLoading(state);

    case CANCEL_APPEAL_SUCCESS:
      return stopLoading(state);

    case CANCEL_APPEAL_FAILURE:
      return hasError(state, action);


    case CANCEL_CORRECTION_BEGIN:
      return startLoading(state);

    case CANCEL_CORRECTION_SUCCESS:
      return stopLoading(state);

    case CANCEL_CORRECTION_FAILURE:
      return hasError(state, action);


    case SUBMIT_CORRECTIBLE_BEGIN:
      return startLoading(state);

    case SUBMIT_CORRECTIBLE_SUCCESS:
      return stopLoading(state);

    case SUBMIT_CORRECTIBLE_FAILURE:
      return hasError(state, action);


    case AGENT_SUBMIT_APPEAL_BEGIN:
      return startLoading(state);

    case AGENT_SUBMIT_APPEAL_SUCCESS:
      return stopLoading(state);

    case AGENT_SUBMIT_APPEAL_FAILURE:
      return hasError(state, action);

    case AGENT_CANCEL_APPEAL_BEGIN:
      return startLoading(state);

    case AGENT_CANCEL_APPEAL_SUCCESS:
      return stopLoading(state);

    case AGENT_CANCEL_APPEAL_FAILURE:
      return hasError(state, action);


    case AGENT_CANCEL_CORRECT_BEGIN:
      return startLoading(state);

    case AGENT_CANCEL_CORRECT_SUCCESS:
      return stopLoading(state);

    case AGENT_CANCEL_CORRECT_FAILURE:
      return hasError(state, action);


    default:
      return state;
  }
};
